import WallsSettings from './WallsSettings.svelte';

export let WallsWidgetApi = {
  Settings: (target, widget, onChange, refreshUI) => {
    return new WallsSettings({ target: target, props: { widget: widget, onChange: onChange, refreshUI: refreshUI } });
  }
};
